import { forwardRef } from "react";
import { Heart } from "lucide-react";
import { useCredits } from "@/hooks/useCredits";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface CreditBubbleProps {
  onClick: () => void;
  className?: string;
}

export const CreditBubble = forwardRef<HTMLButtonElement, CreditBubbleProps>(
  ({ onClick, className }, ref) => {
    const { balance, balanceLoading, hasRecentlyChanged } = useCredits();

    if (balanceLoading) {
      return <Skeleton className="h-8 w-16 rounded-full" />;
    }

    return (
      <button
        ref={ref}
        onClick={onClick}
        className={cn(
          "flex items-center gap-1.5 px-3 py-1.5 rounded-full",
          "bg-gold/10 border border-gold/30",
          "hover:bg-gold/20 hover:border-gold/50",
          "transition-all duration-300 ease-out",
          "hover:scale-105 active:scale-95",
          hasRecentlyChanged && "animate-credit-pulse",
          className
        )}
        aria-label={`Du har ${balance?.totalCredits ?? 0} krediter. Klicka för att öppna butiken.`}
      >
        <Heart 
          className={cn(
            "w-4 h-4 text-red-500 fill-red-500",
            hasRecentlyChanged && "animate-twinkle"
          )} 
        />
        <span className="font-semibold text-sm text-gold-dark">
          {balance?.totalCredits ?? 0}
        </span>
      </button>
    );
  }
);

CreditBubble.displayName = "CreditBubble";
